import { api, signalr } from '@/f1/service'
import agent from '../../WSFinder/agent/service'
// import FolderSetDrag from '../../WSFinder/agent/FolderSet';
import FolderSet from '../../WSFinder/agent/FolderSet.i18n';
import WhitePath from '../../WSFinder/agent/WhitePath';
import Item from '../../WSFinder/agent/Item';
import _ from 'lodash'

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
};

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  "target" : "userinfo",
  "cmd" : "search",
  "request" : "wsf",
  "offset" : 0,
  "limit" : 10,
  adv : false,
  sk : '', sv : '', skt : '', opt : { },
  "body" : {
    "or" : [ { "name" : "username", "value" : "test%", "op" : "like" } ],
    "sort" : [ { "name" : "group_id" }, { "name" : "id", "op" : "desc" } ]
  }
})
const i18n_fields = {
  EN: [
    { key: 'id', label: 'No' , thStyle: 'width: 5%'},
    { key: 'ping', label: 'Status', thStyle: 'width: 10%'},
    { key: 'name', label: 'Name', thStyle: 'width: 10%' },
    { key: 'host', label: 'Host' },
    // { key: 'tag', label: 'Tag',  },
    { key: 'os_type', label: 'OS' },
    { key: 'ip_addr', label: 'IP(Public, Private)',},
    { key: 'setting', label: 'Setting'},
    { key: 'select', label: 'Detail' , thStyle: 'width: 10%'}
  ],
  KO: [
    { key: 'id', label: 'No' , thStyle: 'width: 5%'},
    { key: 'ping', label: '상태', thStyle: 'width: 10%'},
    { key: 'name', label: '이름', thStyle: 'width: 10%' },
    { key: 'host', label: '호스트' },
    // { key: 'tag', label: 'Tag',  },
    { key: 'os_type', label: '운영체제' },
    { key: 'ip_addr', label: 'IP(외부, 내부)'},
    { key: 'setting', label: '설정'},
    { key: 'select', label: '더 보기' , thStyle: 'width: 10%'}
  ]
}

let exp = c => _.flattenDeep(_.concat([], c.child, _.map(c.child, exp)));

export default {
  components: { FolderSet, Item, WhitePath },
  data: () => {
    return {
      request : false,
      agents : [],
      show: true,
      press_save : false,
      so : default_opt(),
      exchange : "",
      path : "",
      model : {},
      th : undefined, // timer handler
      dir : [],
      root : [],
      watching : [],
      watching_history : [],
      white_path : [],
      white_file : [],
      watch : {
        agent_id : 0,
        snapshot : {
          white_file : [],
          watching : [],
          white_path : []
        }
      }
    }
  },
  watch: {
    '$route' (to, from) { this.get(to.params.id); console.debug(from) },
    selected_path(e) {
      if(e) { console.debug("load path") }
      let map = this.selected_path; // items, exsits in tree
      const exclude = _.map(_.filter(exp({ child: this.dir }), { selected: false }), 'abs_path');
      const filter  = _.filter(this.watching, x => _.includes(exclude, x));
      this.watching = _.uniq(_.flatten(_.concat(map, _.filter(this.watching, x => !_.includes(filter, x)))).sort());


    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    fields() { return i18n_fields[this.i18n]; },
    list : function() { return this.agents; },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    selected_path() { return _.map(_.filter(exp({ child: this.dir }), 'selected'), 'abs_path'); },
  },
  methods: {
    clear(type='scan_list') {
      // console.log('clear', type, this.watching)
      switch (type) {
        case 'scan_list': this.watching = []; break;
        case 'white_path': this.white_path = []; break;
        case 'white_file': this.white_file = []; break;
      }
    },
    reset_usage(is_msg = false) { this.white_file = []; this.white_path = [], this.watching = []; this.forgery_mode = false; is_msg ? this.$toastr.i('cleared') : '' },
    add_watching(x) {
      if(_.includes(this.watching, x.abs_path)) { return this.$toastr.w("duplicate") }
      this.watching.push(x.abs_path)
      let t = _.find(exp({ child: this.dir }), { abs_path : x.abs_path })
      if(t) { t.selected = true }
      // console.log("add_watching", x.abs_path, t)
    },
    add_white_list(x) {
      // if(_.includes(this.white_path, x.abs_path)) { return this.$toastr.w("duplicate") }

      // if(_.compact(_.map(this.watching, y => {
      //     if(!_.startsWith(x.abs_path.replace(/\\/gm, ''), y.replace(/\\/gm, ''))) { return y }
      //   })).length > 0) {
      //   // 해당 경로는 넣을 수 없음
      //   return this.$toastr.w('warning', 'It is not included in the folder')
      // }

      this.white_path.push(x.abs_path)

      // console.log("add_white_list", x.abs_path)
    },
    add_white_list_file(x) {
      // if(_.includes(this.white_file, x.abs_path)) { return this.$toastr.w("duplicate") }

      // // console.log(x, this.white_file, this.watching)

      // if(_.filter(this.watching, y => _.startsWith(x.abs_path, y)).length < 1) {
      //   // 해당 경로는 넣을 수 없음
      //   return this.$toastr.w('warning', 'It is not included in the folder2')
      // }

      if(this.white_file === undefined) { this.white_file = [] } // 하위 호환
      this.white_file.push(x.abs_path)

      // console.log("add_white_list", x.abs_path)
    },
    reset() { this.so = default_opt(); this.$refs._list.refresh();},
    refresh() { console.log('refresh'); this.$refs._list.refresh(); this.press_save = false; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        sortBy : "id",
        target : 'agent', cmd : 'list',
        body : { sort : [ { name : "id", op : "desc" } ], or : [], and : [{name: 'is_del', value:false, op: '='}] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      return api.wsfinder.WSFinder(so).then(rs => {
        this.so.totalRows = rs.total;
        this.agents = _.map(rs.body, r => Object.assign(r, { m : 0, alive : false }))
        this.show = rs.count > 0 ? true : false;
        this.ping()
        return this.agents;
      }).catch(e => console.log(e) );
    },
    select(item) { this.request = true; this.model = item; this.$toastr.i("Select done"); this.get(item.id); },
    detail() { this.$router.push(`/wsfinder/agent/${this.model.id}`); },
    ping() {
      if(this.th) { clearTimeout(this.th); }
      if(this.agents &&  this.agents.length) {
        this.agents.forEach(r => agent.ws.Cmd("ping", `${r.id}`).then(rs => this.ws_res(rs)))
        this.th = setTimeout(this.ping, 3000);
      }
    },
    ws_pong(m) {
      var t = _.filter(this.agents, { id : m.agent_id })
      for (let l = 0; l < t.length; l++) {
        let update = { ms : Math.abs(new Date().getTime() - Number(m.body)), alive : true }
        this.agents[_.findIndex(this.agents, { id : m.agent_id })] = _.assign(t[l], update)
      }
    },
    res_path(pl){

      _.forEach(exp(pl), c => { c.open = false; c.selected = _.includes(this.watching, c.abs_path); });

      if(pl.abs_path == '') { this.dir = pl.child; }
      else {
        let t = _.find(exp({ child: this.dir }), { abs_path : pl.abs_path });
        this.ff = pl.abs_path;
        t.child = pl.child;
      }

      this.request = false;
    },
    ws_res(m) {
      if((!m.body && !m.cmd)) { return; }

      m.body = typeof m.body == typeof '' ? JSON.parse(m.body) : m.body
      switch(m.cmd) {
        case 'pong' : return this.ws_pong(m);
        case 'path' : return this.res_path(m.body);
      }
    },
    remove_select(type, s) {
      console.log('this.watching', this.watching, '3')
      if(type == 'scan_list') { this.watching = _.pull(this.watching, s); }
      if(type == 'white_path') { this.white_path = _.pull(this.white_path, s); }
      if(type == 'white_file') { this.white_file = _.pull(this.white_file, s); }

      this.folder();
    },
    res_msg(pl, cmd) {
      if(pl && pl.error) { this.$refreshrefresh.e(pl.reason, `${cmd} failed`); return 'error'; }
      else if(cmd == "status" || cmd == "pong") { return cmd; }
      else { this.$toastr.s(`${cmd} done`); return cmd }
    },
    async folder(){ //폴더 로더
      try{
        if(_.isEmpty(this.path)) { this.get_path(''); }
      } catch(e) { this.catch_msg(e); }
    },
    async get_path(path){ //경로 로더
      try {
        this.$forceUpdate();

        agent.ws.Cmd('path', this.model.id, path.trim())
          .then(rs => this.ws_res(rs))
          .catch(e => this.catch_msg(e))
        // try { this.ws_res(await agent.ws.Cmd('path', this.model.id, path.trim())); } catch(e) { this.catch_msg(e) }
        // agent.ws.Cmd('path', this.model.id, path.trim()).then(rs => this.ws_res(rs))
      } catch(e) { this.catch_msg(e) }
    },
    checkDuplicate () {
      this.watching = _.uniq(this.watching, x => x);
      this.white_path = _.uniq(this.white_path, x => x);
      this.white_file = _.uniq(this.white_file, x => x);
    },
    async save(){
      this.press=true;
      if(!this.model.alive){ return this.$toastr.e('Required agent online');}
      for (let l = 0; l < this.root.length; l++) { if(this.watching.indexOf(this.root[l]) > -1) { return this.$toastr.e('Specifying a top-level folder (drive) is not recommended') } }

      if(this.watching && !this.watching.length && this.model.forgery_mode){ return this.$toastr.e('Need to set folder or file.');}
      try{
        this.checkDuplicate();

        this.watch.is_alive = this.model.setting.forgery_mode;
        this.watch.snapshot.watching = this.watching;
        this.watch.snapshot.white_path = this.white_path;
        this.watch.snapshot.white_file = this.white_file;
        this.watch.agent_id = this.model.id
        // console.log(this.watch)
        if(this.watch.id) { await api.wsfinder.WSFinder_Call('forgery', 'update', this.watch); }
        else { await api.wsfinder.WSFinder_Call('forgery', 'insert',  this.watch ); }

        this.$toastr.s(this.i18n_data['saved'][this.i18n]);
        this.select(this.model);
        this.refresh();
        this.$forceUpdate();
      } catch(e) { this.catch_msg(e); }
    },
    async get(id) {
      console.log('agent.detail.vue', 'load item', this.model.id);
      this.clear();
      try {
        let rs = await api.wsfinder.WSFinder_Call('forgery', 'detail', { type : 'wsfinder', id : this.model.id });
        if(rs.is_error) { return this.$toastr.i('no have forgery setting') }

        let is_new = rs && !rs.error && rs.body.length ? false : true;
        let watch = Object.assign(this.watch, rs.body ? rs.body : {  snapshot : { watching : [], white_path : [], white_file : [] } });

        if(is_new) { this.watch.agent_id = id; this.model.setting.forgery_mode = false; }
        else { this.watch.id = rs.body.id;  }
        this.model.setting.forgery_mode = rs.body.is_alive;
        this.watching = watch.snapshot.watching && watch.snapshot.watching.length ? watch.snapshot.watching : []
        this.watching_history = watch.snapshot.watching_history && watch.snapshot.watching_history.length ? watch.snapshot.watching_history : []
        this.white_path = watch.snapshot.white_path && watch.snapshot.white_path.length ? watch.snapshot.white_path : []
        this.white_file = watch.snapshot.white_file && watch.snapshot.white_file.length ? watch.snapshot.white_file : []
        this.checkDuplicate();

        this.folder();

      } catch(e) { this.catch_msg(e); }
    },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
  },
  created() { console.log('agent.list.vue', 'created'); },
  destroyed() {
    console.log('agent.list.vue', 'destroyed');
    // this.signalr.off('wsfinder_response');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
  },
  mounted() {
    this.$forceUpdate();
    console.log('agent.list.vue', 'mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    // this.signalr.on('wsfinder_response', this.ws_res);
    signalr.subscribe('wsfinder_response', this.ws_res)
  },
}
